import { ControllerFieldState } from "react-hook-form";
import { CharacterLimitExceeded } from "constants/text.ts";
import { MAX_NOTES_LENGTH } from "pages/CustomQuote/AddQuotePage/utils/fileUtils.ts";

export const inputErrorHandling = (
	value: string | null | undefined,
	fieldState: ControllerFieldState | null | undefined
) => {
	if (value && value?.length > MAX_NOTES_LENGTH) {
		return CharacterLimitExceeded;
	}

	if (fieldState?.error) {
		return fieldState.error.message;
	}
};
